/**
 * What each run status is called on the card. Queued is its own word, not
 * "done": a review or backtest the agent enqueued has not produced anything
 * yet, and the card must not say otherwise.
 */
const STATUS_LABEL = {
  waiting: 'Waiting',
  confirm: 'Needs your OK',
  running: 'Running',
  done: 'Done',
  queued: 'Queued',
  failed: 'Failed',
  cancelled: 'Cancelled',
  expired: 'Expired',
};

/**
 * One action the agent started — an analysis, a review, a write — and where
 * it has got to.
 *
 * The result itself is shown by the screen that ran it (the agent navigates
 * there first), so the card is only the receipt: its title, a status pill and
 * the one-line detail the runner settled with. The pill is a polite live
 * region, so a reader using a screen reader hears "Done" or "Failed" when the
 * status changes without having to find the card again.
 */
export default function RunCard({ message }) {
  const card = message?.card;
  if (!card) return null;
  const status = card.status || 'waiting';
  const label = STATUS_LABEL[status] || status;

  return (
    <div className={`cp-card cp-run s-${status}`}>
      <div className="cp-card-row">
        <b className="cp-card-title">{card.title || 'Agent action'}</b>
        <span className={`cp-status s-${status}`} role="status" aria-live="polite">
          {status === 'running' && <span className="dots cp-dots" aria-hidden="true"><i /><i /><i /></span>}
          {label}
        </span>
      </div>
      {card.detail && <p className="cp-card-detail">{card.detail}</p>}
    </div>
  );
}
